<script setup>
  import { defineEmits, onMounted, computed, ref } from 'vue';
  import { useCartAndLibrariesStore } from '../../stores/CartAndLibrariesStore';

  import { useOfferStore } from '../../stores/OfferStore';
  import Button from '../ui/Button.vue';
  import Loader from '../ui/Loader.vue';
  import Notice from '../ui/Notice.vue';
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();
  const emits = defineEmits();
  const offerStore = useOfferStore();
  const cartAndLibrariesStore = useCartAndLibrariesStore();
  const props = defineProps({
    cartId: {
      type: String,
      required: true
    },
    moveType: {
      type: String,
      required: false,
      default: 'move'
    }
  });
  cartAndLibrariesStore.cart = null;
  cartAndLibrariesStore.errors = null;
  const errorsForm = computed(() => {
    return cartAndLibrariesStore.errors;
  });

  const loading = computed(() => {
    return cartAndLibrariesStore.loading;
  });
  const carts = computed(() => {
    return cartAndLibrariesStore.carts;
  });
  const libraries = computed(() => {
    return cartAndLibrariesStore.libraries;
  });
  const closeModal = () => {
    emits('close')
  }
  const onCartSelect = (e) => {
    const allItems = [...(carts.value || []), ...(libraries.value || [])];
    const item = allItems.find(i => i.id == e.target.value);
    if (item) formData.value.destination_cart_id = item.id;
  };

  const offersSelected = computed(() => {
    return offerStore.offersSelected.map(item => item.offer.id).join(',')
  });

  const formData = ref({
    destination_cart_id: '',
    destination_cart_name: '',
    ids: offersSelected.value,
    radio_move_items: ''
  });

  const submitForm = async () => {
    await cartAndLibrariesStore.createCardAndMovieOffers(props.cartId, formData.value, props.moveType)
    if (cartAndLibrariesStore.errors === null && props.moveType === 'move') {
      offerStore.offers = offerStore.notSelectedOffers
    }
  }

  const hasValues = computed(() => {
    if (formData.value.radio_move_items === 'new') {
      return formData.value.destination_cart_name.trim().length >= 3;
    }
    if (formData.value.radio_move_items === 'active') {
      return formData.value.destination_cart_id !== '';
    }
    return false;
  });



  const cartSuccess = computed(() => {
    return cartAndLibrariesStore.cart; 
  });

  const saveButton = computed(() => {
    if(props.moveType == 'copy'){
      return t('cart.form.copy')
    }
    return t('cart.form.save')
  })

  const messageSuccess = computed(() => {
    if(props.moveType == 'copy'){
      return t('cart.form.move_items.copy_success')
    }
    return t('cart.form.move_items.success')
  })

  onMounted (() => {
    cartAndLibrariesStore.fetchCartsAndLibraries(props.cartId);
  });
</script>

<template>
  <Loader v-if="loading" />
  <Notice :title="errorsForm.title" type="error" v-if="errorsForm">
    {{ errorsForm.details }}
  </Notice>
  <Notice v-if="cartSuccess">
    {{ messageSuccess }} 
    <router-link :to="`/carts/${cartSuccess.id}`" replace>
     {{ cartSuccess.name }}
    </router-link>
  </Notice>

  <form v-if="!loading && !cartSuccess" @submit.prevent="submitForm">
    <div class="mb-3">
      <div class="form-check">
        <input class="form-check-input" type="radio" name="radio_move_items" value="new" id="radio-new" v-model="formData.radio_move_items">
        <label class="form-check-label" for="radio-new">{{ t('cart.form.destination_cart_name') }}</label>
      </div>
      <div v-if="formData.radio_move_items === 'new'" class="mt-2">
        <input class="form-control" type="text" id="new_cart" v-model="formData.destination_cart_name" :placeholder="t('cart.form.destination_cart_name')">
      </div>
    </div>

    <div class="mb-3" v-if="!loading && (carts.length > 0 || libraries.length > 0)">
      <div class="form-check">
        <input class="form-check-input" type="radio" name="radio_move_items" value="active" id="radio-active" v-model="formData.radio_move_items">
        <label class="form-check-label" for="radio-active">{{ t('cart.form.current_carts') }}</label>
      </div>
      <div v-if="formData.radio_move_items === 'active'" class="mt-2">
        <select class="form-select" id="destination_cart" @change="onCartSelect">
          <option value="" disabled selected>{{ t('cart.form.select_cart') }}</option>
          <optgroup v-if="carts.length > 0" :label="t('cart.form.destination_cart_name')">
            <option v-for="cart in carts" :key="cart.id" :value="cart.id">{{ cart.name }}</option>
          </optgroup>
          <optgroup :label="t('cart.form.current_carts')">
            <option v-for="library in libraries" :key="library.id" :value="library.id">{{ library.name }}</option>
          </optgroup>
        </select>
      </div>
    </div>

    <div class="button-bar">
      <Button type_button="submit" class="btn btn-primary" :disabled="!hasValues">
        {{ saveButton }}
      </Button>
      <Button type_button="button" class="btn btn-outline-secondary" @click.prevent="closeModal">
        {{ t('cart.form.cancel') }}
      </Button>
    </div>
  </form>
</template>


